module.exports = __webpack_public_path__ + "img/sv30on.f4297f8c.svg";